import RadiobuttonListFilter, { Option } from '../../../components/Filters/RadiobuttonListFilter';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FilterProps } from './FilterProps';

const valueIsEmpty = (v?: string) => !v?.length;
export interface PaymentOperationFilterProps extends FilterProps {
    enabledPaymentOperations: string[];
}

const PaymentOperationFilter = (
    {
        queryParams,
        t,
        onChange,
        enabledPaymentOperations = ['unscheduled_purchase', 'recurring_purchase'],
    }: PaymentOperationFilterProps
) => {
    const options: Option[] = enabledPaymentOperations ? [
        ...enabledPaymentOperations.map((value) => ({ value, label: t(`payments.payment_operation_short.${value}`) })),
    ] : [];
    const value = queryParams.get('payment_operation') ?? '';
    return (
        <RadiobuttonListFilter 
            label={t('payments.filter.payment_operation.label', {
                value: valueIsEmpty(value) ? t('payments.filter.payment_operation.unselected') : t(`payments.payment_operation_short.${value}`),
            })} 
            title={t('payments.filter.payment_operation.title')} 
            name="payment_operation" 
            options={options} 
            value={value} 
            onApply={(name: string, v: string) => {
                onChange({
                    [name]: [v],
                });
            }}
            onDelete={(name: string) => {
                onChange({
                    payment_operation: [],
                });
            }}
        />
    );
};

export default withTranslation()(PaymentOperationFilter);
